import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Inject,
  PLATFORM_ID
} from '@angular/core';

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BannerService } from '../../services/banner.service';


// হোমপেজের প্রতিটি সেকশনের পরে বসানো বিজ্ঞাপন স্লট।
// <app-ad-slot slot="AFTER_HOT_DEALS"></app-ad-slot>
// ওই slot-এ admin কোনো ব্যানার না দিলে কিছুই দেখায় না (ফাঁকা জায়গাও থাকে না)।
@Component({
  selector: 'app-ad-slot',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './ad-slot.html',
  styleUrls: ['./ad-slot.css']
})
export class AdSlot implements OnInit, OnDestroy {

  @Input() slot = '';

  ads: any[] = [];

  current = 0;

  private timer: any;

  constructor(
    private banners: BannerService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {

    this.banners.getBySlot(this.slot).subscribe(list => {

      this.ads = list;

      this.cdr.markForCheck();

      if (list.length > 1 && isPlatformBrowser(this.platformId)) {

        this.timer = setInterval(() => {

          this.current = (this.current + 1) % this.ads.length;

          this.cdr.markForCheck();

        }, 4000);
      }
    });
  }

  ngOnDestroy(): void {

    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  isInternal(url: string): boolean {
    return !!url && url.startsWith('/');
  }

  go(i: number): void {
    this.current = i;
  }
}
